import classes from './SidePopup.module.css';
import successImg from '../../../images/message-success-circle.svg';
import errorImg from '../../../images/message-error.svg';
import closeImg from '../../../images/Close-dark.svg';

const SidePopup = ({ type = 'info', header, message, autoDismiss = true, duration = 4500, onClose, zIndex }) => {
    // Map type to icon and CSS class
    const getTypeConfig = (type) => {
        switch (type) {
            case 'success':
                return { icon: successImg, cssClass: classes.success };
            case 'error':
                return { icon: errorImg, cssClass: classes.error };
            case 'warning':
                return { icon: errorImg, cssClass: classes.warning }; // Use error icon for warning
            case 'info':
                return { icon: successImg, cssClass: classes.info }; // Use success icon for info
            default:
                return { icon: successImg, cssClass: classes.info };
        }
    };

    const { icon, cssClass } = getTypeConfig(type);

    return (
        <div
            className={`${classes.popup} ${cssClass} ${autoDismiss ? classes.autoDismiss : classes.manualDismiss}`}
            style={zIndex != null ? { zIndex } : undefined}
        >
            <img alt='' src={icon} className={classes.typeIcon} />
            <div className={classes.messages}>
                <p className={classes.header}>{header}</p>
                <p className={classes.message}>{message}</p>
            </div>
            {!autoDismiss && onClose && (
                <img 
                    alt='Close' 
                    src={closeImg} 
                    className={classes.closeButton}
                    onClick={onClose}
                />
            )}
        </div>
    );
};

export default SidePopup;
